/**
 * A neatline with the section's name printed on it, the way a chart labels its
 * panels. The index is document order, which is the only sequence here.
 */
export function SectionRule({
  index,
  label,
}: {
  index: string;
  label: string;
}) {
  return (
    <div className="flex items-center gap-4">
      <span className="marginalia text-beacon">{index}</span>
      <h2 className="marginalia text-ink">{label}</h2>
      <span aria-hidden="true" className="h-px flex-1 bg-rule" />
    </div>
  );
}
